export const previewModeEnabled = () => {
  return sessionStorage.getItem("previewMode") === "true";
};

export const openUrlInPreviewMode = (url: string) => {
  const domain = location.protocol + "//" + location.host;
  window.open(
    `${domain}${url.startsWith("/") ? "" : "/"}${url}?previewMode=true`,
    "_blank",
  );
};
